// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const padding = pxToRemArray([20, 26]);

/* Store Custom Code - Start */
const buttonStyle = () => css`
    background-color: ${getColor("common.background")};
    border-color: ${getColor("common.background")};
`;
/* Store Custom Code - End */

const modal: Styleguide["modal"] = {
    defaultProps: {
    /* Store Custom Code - Start */
        cssOverrides: {
            titleButton: css`
                ${({ theme }) => theme.modal?.defaultProps?.cssOverrides?.titleButton}

                &:hover {
                    ${buttonStyle()};
                }
            `,
        },
        closeButtonProps: {
            css: css`
                ${buttonStyle()};
                width: ${pxToRem(50)};
                padding: 0;

                &:hover,
                &:active,
                &:focus {
                    ${buttonStyle()};
                }
            `,
        },
    },
    /* Store Custom Code - End */
};

export default modal;
